// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.virtual-swiper {
  --swiper-height: 100%;
  --slide-size: 460px;
  --slide-margin: 0px;
  --snap-stop-type: always;
  --snap-align-type: center;
  position: relative;
  width: 100%;
  height: var(--swiper-height);
  pointer-events: none;
}
.virtual-swiper .slider {
  width: 100%;
  height: var(--swiper-height);
  white-space: nowrap;
  overflow: hidden;
  position: relative;
  display: flex;
  -webkit-overflow-scrolling: touch;
  scroll-behavior: auto;
  box-sizing: border-box;
  will-change: scroll;
  pointer-events: auto;
}
.virtual-swiper .slider.horizontal {
  scroll-snap-type: x mandatory;
  overflow-x: auto;
  touch-action: pan-x pan-y;
}
.virtual-swiper .slider.vertical {
  scroll-snap-type: y mandatory;
  overflow-y: auto;
  touch-action: pan-x pan-y;
}
.virtual-swiper .cdk-virtual-scroll-orientation-horizontal .cdk-virtual-scroll-content-wrapper {
  height: var(--swiper-height);
  padding-left: calc(50% - var(--slide-size) / 2 + var(--slide-margin) * -1);
  padding-right: calc(50% - var(--slide-size) / 2 + var(--slide-margin) * -1);
}
.virtual-swiper .cdk-virtual-scroll-orientation-vertical .cdk-virtual-scroll-content-wrapper {
  padding-top: calc(var(--swiper-height) / 2 - var(--slide-size) / 2);
  padding-bottom: calc(var(--swiper-height) / 2 - var(--slide-size) / 2);
}
.virtual-swiper .slide {
  position: relative;
  vertical-align: top;
  justify-content: center;
  padding-left: 0px;
  padding-right: 0px;
  overflow: hidden;
  scroll-snap-align: var(--snap-align-type);
  scroll-snap-stop: var(--snap-stop-type);
  box-sizing: border-box;
  will-change: transform;
  user-select: none;
  -webkit-user-select: none;
}
.virtual-swiper .slide img {
  -webkit-user-drag: none;
}
.virtual-swiper .active-slide {
  will-change: transform;
}
.virtual-swiper .prev-slide {
  will-change: transform;
}
.virtual-swiper .next-slide {
  will-change: transform;
}
.virtual-swiper .slide.horizontal {
  width: var(--slide-size);
  height: 100%;
  display: inline-flex;
  margin-left: var(--slide-margin);
  margin-right: var(--slide-margin);
}
.virtual-swiper .slide.vertical {
  height: var(--slide-size);
  width: 100%;
  display: block;
  margin-top: var(--slide-margin);
  margin-bottom: var(--slide-margin);
}
.virtual-swiper .slider::-webkit-scrollbar {
  display: none;
}
.virtual-swiper .pagination {
  position: relative;
  overflow: hidden;
  --active-link-color: currentColor;
  width: 100%;
  text-align: center;
  left: 0;
  box-sizing: border-box;
  pointer-events: initial;
  margin-top: 4px;
  height: 30px;
  margin-top: -30px;
}
.virtual-swiper .pagination .bullet {
  width: 15px;
  height: 15px;
  display: inline-block;
  background: #555;
  border-radius: 100%;
  margin: 0 5px;
  transition: 0.2s;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
}
.virtual-swiper .pagination .bullet:hover {
  cursor: pointer;
  transform: scale(1.1);
  transition: 0.2s;
}
.virtual-swiper .pagination .active {
  background: var(--active-link-color);
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/virtual-swiper/virtual-swiper.component.scss"],"names":[],"mappings":"AAAA;EAEI,qBAAA;EACA,mBAAA;EACA,mBAAA;EACA,wBAAA;EACA,yBAAA;EAEA,kBAAA;EACA,WAAA;EACA,4BAAA;EACA,oBAAA;AADJ;AAKI;EACI,WAAA;EACA,4BAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,iCAAA;EACA,qBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;AAHR;AAOI;EACI,6BAAA;EACA,gBAAA;EACA,yBAAA;AALR;AAQI;EACI,6BAAA;EACA,gBAAA;EACA,yBAAA;AANR;AASI;EACI,4BAAA;EACA,0EAAA;EACA,2EAAA;AAPR;AAUI;EACI,mEAAA;EACA,sEAAA;AARR;AAWI;EACI,kBAAA;EACA,mBAAA;EACA,uBAAA;EAEA,iBAAA;EACA,kBAAA;EACA,gBAAA;EAGA,yCAAA;EACA,uCAAA;EACA,sBAAA;EACA,sBAAA;EACA,iBAAA;EACA,yBAAA;AAZR;AAcQ;EACI,uBAAA;AAZZ;AAiBI;EAEI,sBAAA;AAhBR;AAmBI;EAEI,sBAAA;AAlBR;AAqBI;EAEI,sBAAA;AApBR;AAuBI;EAEI,wBAAA;EACA,YAAA;EACA,oBAAA;EACA,gCAAA;EACA,iCAAA;AAtBR;AAyBI;EACI,yBAAA;EACA,WAAA;EACA,cAAA;EACA,+BAAA;EACA,kCAAA;AAvBR;AA0BI;EACI,aAAA;AAxBR;AA2BI;EACI,kBAAA;EACA,gBAAA;EACA,iCAAA;EACA,WAAA;EACA,kBAAA;EACA,OAAA;EACA,sBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;AAzBR;AA2BQ;EACI,WAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,wCAAA;AAzBZ;AA2BQ;EACI,eAAA;EACA,qBAAA;EACA,gBAAA;AAzBZ;AA2BQ;EACI,oCAAA;AAzBZ","sourcesContent":[".virtual-swiper {\n    // Obs.. 'swiper-height', 'slide-size' and 'slide-margin' will be overwritten dynamicsally by input from component\n    --swiper-height: 100%;\n    --slide-size: 460px;\n    --slide-margin: 0px;\n    --snap-stop-type: always;\n    --snap-align-type: center;\n\n    position: relative;\n    width: 100%;\n    height: var(--swiper-height);\n    pointer-events: none;\n    // padding: 20px;\n    // width: calc(100% - 40px);\n\n    .slider {\n        width: 100%;\n        height: var(--swiper-height);\n        white-space: nowrap;\n        overflow: hidden;\n        position: relative;\n        display: flex;\n        -webkit-overflow-scrolling: touch;\n        scroll-behavior: auto;\n        box-sizing: border-box;\n        will-change: scroll;\n        pointer-events: auto;\n        // background-color: #ff775571;\n    }\n    \n    .slider.horizontal {\n        scroll-snap-type: x mandatory;\n        overflow-x: auto;\n        touch-action: pan-x pan-y;\n    } \n\n    .slider.vertical {\n        scroll-snap-type: y mandatory;\n        overflow-y: auto;\n        touch-action: pan-x pan-y;\n    } \n    \n    .cdk-virtual-scroll-orientation-horizontal .cdk-virtual-scroll-content-wrapper {\n        height: var(--swiper-height);\n        padding-left: calc(50% - var(--slide-size) / 2 + var(--slide-margin) * -1);\n        padding-right: calc(50% - var(--slide-size) / 2 + var(--slide-margin) * -1);\n    }\n    \n    .cdk-virtual-scroll-orientation-vertical .cdk-virtual-scroll-content-wrapper {\n        padding-top: calc((var(--swiper-height) / 2) - calc(var(--slide-size) / 2));\n        padding-bottom: calc((var(--swiper-height) / 2) - calc(var(--slide-size) / 2));\n    }\n\n    .slide {\n        position: relative;\n        vertical-align: top;\n        justify-content: center;\n        // padding: 30px;\n        padding-left: 0px;\n        padding-right: 0px;\n        overflow: hidden;\n        // background-color: green;\n        // Snap to start of slide on scroll\n        scroll-snap-align: var(--snap-align-type);\n        scroll-snap-stop: var(--snap-stop-type);\n        box-sizing: border-box;\n        will-change: transform;\n        user-select: none;\n        -webkit-user-select: none;\n\n        img {\n            -webkit-user-drag: none;\n        }\n        // background-color: rgba(46, 185, 46, 0.301)\n    }\n\n    .active-slide {\n        // background-color: red;\n        will-change: transform;\n    }\n\n    .prev-slide {\n        // background-color: red;\n        will-change: transform;\n    }\n\n    .next-slide {\n        // background-color: green;\n        will-change: transform;\n    }\n\n    .slide.horizontal {\n        // OBS: We must define width, otherwise padding wont be taking into account on auto scroll\n        width: var(--slide-size);\n        height: 100%;\n        display: inline-flex;\n        margin-left: var(--slide-margin);\n        margin-right: var(--slide-margin);\n    }\n\n    .slide.vertical {\n        height: var(--slide-size);\n        width: 100%;\n        display: block;\n        margin-top: var(--slide-margin);\n        margin-bottom: var(--slide-margin);\n    }\n\n    .slider::-webkit-scrollbar {\n        display: none;\n    }\n\n    .pagination {\n        position: relative;\n        overflow: hidden;\n        --active-link-color: currentColor;\n        width: 100%;\n        text-align: center;\n        left: 0;\n        box-sizing: border-box;\n        pointer-events: initial;\n        margin-top: 4px;\n        height: 30px;\n        margin-top: -30px;\n\n        .bullet {\n            width: 15px;\n            height: 15px;\n            display: inline-block;\n            background: #555;\n            border-radius: 100%;\n            margin: 0 5px;\n            transition: .2s;\n            box-shadow: 0 2px 5px rgba(0,0,0,.3);\n        }\n        .bullet:hover {\n            cursor: pointer;\n            transform: scale(1.1);\n            transition: .2s;\n        }\n        .active {\n            background: var(--active-link-color);\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
